import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
const BigText = ({
  children
}) => {
  return /*#__PURE__*/_jsx(Text, {
    typography: "body-200",
    children: children
  });
};
export default BigText;